import { State } from "source/app/services/UI/State/State";
import { IDreamsState } from "../IDreamsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { GetEnergyHashTags } from "./HideEnergyHashtagsLink";

export function GetEnergyHashTagsSearchText() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (!dreams) {
        return ``;
    }

    const allDreams = dreams.state.dreamsdata;
    const energyHashTags = GetEnergyHashTags(allDreams);

    const energyHashTagsSearchText = energyHashTags
        .map((hashTag) => `!${hashTag}`)
        .join(" ");

    return energyHashTagsSearchText;
}
